function IsEmail(login_email) {
  var regex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
  if (!regex.test(login_email)) {
      return false;
  } else {
      return true;
  }
}
$(document).ready(function () {

  var myaccount = $(".thb-secondary-myaccount").attr("href");
  var myaccountmobile = $(".thb-mobile-account-link").attr("href");
  
  if(myaccount.indexOf('/account/login') != -1){
     $(".thb-secondary-myaccount").attr("href","javascript:void(0);"); 
    // console.log(myaccount)
  }
  if(myaccountmobile.indexOf('/account/login') != -1){ 
     $(".thb-mobile-account-link.mobile_account_link").attr("href","javascript:void(0);"); 
  }
 
  $(document).on("input", "input#loginform_email", function () { 
    var login_email = $('.login_email_input').val();
    var is_valid = true;
    if (login_email == "") {
      $("#login_invalid_email").text("Please enter your email address").show();
      is_valid = false;
    } else {
      $("#login_invalid_email").text("Please enter your email address").hide();
    }
  }); 
    
  $(document).on("input", "#customer_login input#pwd", function () { 
    var login_password = $('.login_password').val();  
    var is_valid = true;
    if (login_password == "") {
      $('#login_invalid_password').text("Please enter your password").show();
      is_valid = false;
    } else {
      $('#login_invalid_password').hide();
    }
  }); 
  
  $(document).on("input", "input.create_email_field", function () {  
    var create_email_field = $('.create_email_field').val();
    var is_valid = true;
    if (create_email_field == "") {
      $('#create_invalid_email').text("Please enter your email address").show();
      is_valid = false;
    }  else{
      $('#create_invalid_email').hide();
    }
  }); 
  
  $(document).on("input", "input.create_password_field", function () { 
    var create_password_field = $('.create_password_field').val();
    var is_valid = true;
    if (create_password_field == "") {
      $('#create_invalid_password').text("Please enter your password").show();
      is_valid = false;
    }else {
      $('#create_invalid_password').hide();
    }
  });   
   $(document).on("input", "input.create_fname_field ", function () { 
    var create_password_field = $('.create_fname_field ').val();
    var is_valid = true;
    if (create_password_field == "") {
      $('#create_invalid_fname').text("Please enter your First Name").show();
      is_valid = false;
    }else {
      $('#create_invalid_fname').hide();
    }
  });   
   $(document).on("input", "input.create_lname_field", function () { 
    var create_password_field = $('.create_lname_field full').val();
    var is_valid = true;
    if (create_password_field == "") {
      $('#create_invalid_lname').text("Please enter your Last Name").show();
      is_valid = false;
    }else {
      $('#create_invalid_lname').hide();
    }
  });   
  
  $(document).on("input", "select#CustomerFormDropdown", function () { 
  var is_valid = true;
  if( $('select#CustomerFormDropdown').val() == "--" ) { 
    $("#create_invalid_title").text("Please enter a Title.").show();
    var is_valid = false;
  }else {
   $("#create_invalid_title").hide();
  }
}); 
  
}); 

$(document).on("click", ".user_account_submit", function (event) { 
  event.preventDefault();
  var login_email = $('.login_email_input').val();
  var login_password = $('.login_password').val();
  var create_title_field = $('.create_title_field').val();
  var create_fname_field = $('.create_fname_field').val();
  var create_lname_field = $('.create_lname_field').val();
  var create_email_field = $('.create_email_field').val();
  var create_password_field = $('.create_password_field').val();
  var is_valid = true;
  var login_error_blank = $('.login_page_error').html(" ");
  var create_error_blank = $('.create_page_error').html(" ");
  var data_event = $(this).attr("data-event");
  if(data_event == 'customer_login'){
    if (login_email == "") {
        $('#login_invalid_email').text("Please enter your email address").show();
        is_valid = false;
    } else if(IsEmail(login_email) == false){
      $('#login_invalid_email').text("Enter valid email address.").show();
      is_valid = false;
    }
  
    if (login_password == "") {
        $('#login_invalid_password').text("Please enter your password").show();
        is_valid = false;
    }
  }
  if(data_event == 'create_customer'){
    if (create_title_field == "") {
        $('#create_invalid_title').text("Please enter a title.").show();
        is_valid = false;
    }
    if (create_fname_field == "") {
        $('#create_invalid_fname').text("First name is required.").show();
        is_valid = false;
    }
    if (create_lname_field == "") {
        $('#create_invalid_lname').text("Last name is required.").show();
        is_valid = false;
    }
    if (create_email_field == "") {
        $('#create_invalid_email').text("Please enter your email address").show();
        is_valid = false;
    } else if(IsEmail(create_email_field) == false){
      $('#create_invalid_email').text("Enter valid email address.").show();
      is_valid = false;
    }
    if (create_password_field == "") {
        $('#create_invalid_password').text("Please enter your password").show();
        is_valid = false;
    }
    
  }
  if(is_valid == false){
    return false;
  }
   
  var data_action = $("."+data_event+"_form").attr("action");
  var data = $("."+data_event+"_form").serialize();
  // console.log("data_action",data_action);
  // console.log("data",data);
  $(".form-notification").html("");
  $.post(data_action, data).done(function(response){
    // console.log(response);
    $('.customer_login_form_error').show();
    if(data_event=="recover_customer_password"){
      var logErrors = $(response).find('.'+data_event+'_form_error').text(); 
    }else{
      var logErrors = $(response).find('.'+data_event+'_form_error').find('.errors').text(); 
    } 
    var logErrorsHtml =$(response).find('.'+data_event+'_form_error').html();
    if (logErrors != '' && logErrors != 'undefined'){
      $("."+data_event+"_form_error").html(logErrorsHtml);
    }else{
      if(data_event=="create_customer"){
        window.location.reload();
      }else if(data_event=="customer_login"){
        window.location.href = "/account"; 
      }else if(data_event=="recover_customer_password"){
        window.location.href = window.location.origin + "/#login";
      }else{
        window.location.reload();
      }
    }
  }).fail(function(jqXHR, textStatus, errorThrown) {
    // console.error('AJAX request failed: ', textStatus, errorThrown);
    alert('Too many attempts: Please try again later.');
  });
  return false; 
});

//Home Page Heade manu open and close to add class code Start
$(document).on("click", ".thb-secondary-myaccount , .thb-mobile-account-link.mobile_account_link", function () { 
  setTimeout(function(){
    $("#loginform_email").focus();
  }, 800);
  var myaccount = $(this).attr("href");
  // console.log(myaccount);
  if(myaccount!='/account'){
    $("body").addClass("account_drawer");
    $(".account_form_div").show();
    $('.customer_login_form_error').hide();
  }

  var myAcInterval = setInterval(function () {
    // $('form#create_customer div:nth-child(6)')[1].remove();
    $('form#customer_login div:nth-child(6), form#create_customer div:nth-child(7)').addClass("custom-text-account");
    // $('form#customer_login div:nth-child(6)').html('').append("<span class='txt_or'>OR</span>");
    // console.log($("form#create_customer .bottom_field_buton"));
    // $("<div class='custom-text-account'><span class='txt_or'>OR</span></div>").insertAfter('form#create_customer .bottom_field_buton');
    clearInterval(myAcInterval);
  },2000); 
});

$(document).on('click','.hide_show',function(){
  var gt_attr = $(this).parent().find('.input_password').attr('type');
  if(gt_attr == 'password') {
    $(this).text('Hide');
    $(this).parent().find('.input_password').attr('type', "text");
  } else {
    $(this).text('Show');
    $(this).parent().find('.input_password').attr('type', "password");
  }
});  

$("#CustomerFormDropdown").change(function() {
  $("#CustomerFormDropdown option:first-child").attr("disabled", "true");
});

$(document).on("click", function (e) {
  var container = $(".account_form_div");
  var myaccount = $(".thb-secondary-myaccount"); 
  var myaccountmobile = $(".thb-mobile-account-link");
  var hide_show_psw = $(".hide_show");
  if (!container.is(e.target) && container.has(e.target).length === 0 && !hide_show_psw.is(e.target) && hide_show_psw.has(e.target).length === 0 && !myaccount.is(e.target) && myaccount.has(e.target).length === 0 && !myaccountmobile.is(e.target) && myaccountmobile.has(e.target).length === 0) {
    $("body").removeClass("account_drawer");
    $("#account_login_form").show();
    $("#account_register_form").hide();
    $("#login_invalid_email").hide();
    $("#login_invalid_password").hide();
    $('#customer_login')[0].reset();
  }
});

$(document).on("click", ".account_form_div .close_icon", function () { 
  $("body").removeClass("account_drawer");
  $("#account_login_form").show();
  $("#account_register_form").hide();
  $("#login_invalid_email").hide();
  $("#login_invalid_password").hide();
  $('.customer_login_form_error').hide();
  $('#customer_login')[0].reset();
});

$(document).on("click", ".already_account", function () { 
  $('#customer_login')[0].reset();
  $("#account_register_form").hide();
  $("#account_login_form").show(); 
  setTimeout(function(){
    $("#loginform_email").focus();
  }, 800);
  $("#login_invalid_email").hide();
  $('.customer_login_form_error').hide();
  $("#login_invalid_password").hide();
});

$(document).on("click", ".create_new_account", function () { 
  $('.create_customer_form')[0].reset();
  $("#account_login_form").hide();
  $("#account_register_form").show(); 
  $("#create_invalid_title").hide();
  $("#create_invalid_email").hide();
  $("#create_invalid_password").hide();
});

//Home Page Heade manu open and close to add class code End